import React from 'react'
import "./styles/courseSingleP.css"

const CoursePageSingle = () => {
  return (
    <div>
        <div className="frame">
      <div className="overlap-wrapper">
        <div className="overlap">
          <div className="overlap-group">
            <div className="div">
              <div className="overlap-2">
                <div className="undraw-laravel-and">
                  <div className="overlap-3">
                    <div className="overlap-group-2">
                      <img className="vector" alt="Vector" src="/img/vec/img/vector.svg" />
                      <img className="img" alt="Vector" src="/img/vec/img/image.svg" />
                      <img className="img" alt="Vector" src="/img/vec/img/vector-2.svg" />
                      <img className="vector-2" alt="Vector" src="/img/vec/img/vector-3.svg" />
                      <img className="vector-3" alt="Vector" src="/img/vec/img/vector-4.svg" />
                      <img className="vector-4" alt="Vector" src="/img/vec/img/vector-5.svg" />
                      <img className="vector-5" alt="Vector" src="/img/vec/img/vector-6.svg" />
                      <img className="vector-6" alt="Vector" src="/img/vec/img/vector-7.svg" />
                      <img className="vector-7" alt="Vector" src="/img/vec/img/vector-8.svg" />
                      <img className="vector-8" alt="Vector" src="/img/vec/img/vector-9.svg" />
                      <img className="vector-9" alt="Vector" src="/img/vec/img/vector-10.svg" />
                      <img className="vector-10" alt="Vector" src="/img/vec/img/vector-11.svg" />
                      <img className="vector-11" alt="Vector" src="/img/vec/img/vector-12.svg" />
                      <img className="vector-12" alt="Vector" src="/img/vec/img/vector-13.svg" />
                      <img className="vector-13" alt="Vector" src="/img/vec/img/vector-14.svg" />
                      <img className="vector-14" alt="Vector" src="/img/vec/img/vector-15.svg" />
                      <img className="vector-15" alt="Vector" src="/img/vec/img/vector-16.svg" />
                      <img className="vector-16" alt="Vector" src="/img/vec/img/vector-17.svg" />
                      <img className="vector-17" alt="Vector" src="/img/vec/img/vector-18.svg" />
                      <img className="vector-17" alt="Vector" src="/img/vec/img/vector-19.svg" />
                      <img className="vector-18" alt="Vector" src="/img/vec/img/vector-20.svg" />
                      <img className="vector-19" alt="Vector" src="/img/vec/img/vector-21.svg" />
                      <div className="text-wrapper">TUTORIALS</div>
                      <img className="vector-20" alt="Vector" src="/img/vec/img/vector-22.svg" />
                      <img className="vector-21" alt="Vector" src="/img/vec/img/vector-23.svg" />
                      <img className="vector-22" alt="Vector" src="/img/vec/img/vector-24.svg" />
                      <img className="vector-23" alt="Vector" src="/img/vec/img/vector-25.svg" />
                      <img className="vector-24" alt="Vector" src="/img/vec/img/vector-26.svg" />
                      <img className="vector-25" alt="Vector" src="/img/vec/img/vector-27.svg" />
                      <img className="vector-26" alt="Vector" src="/img/vec/img/vector-28.svg" />
                      <img className="vector-27" alt="Vector" src="/img/vec/img/vector-29.svg" />
                      <img className="vector-28" alt="Vector" src="/img/vec/img/vector-30.svg" />
                      <img className="vector-29" alt="Vector" src="/img/vec/img/vector-31.svg" />
                      <img className="vector-30" alt="Vector" src="/img/vec/img/vector-32.svg" />
                      <img className="vector-31" alt="Vector" src="/img/vec/img/vector-33.svg" />
                      <img className="vector-32" alt="Vector" src="/img/vec/img/vector-34.svg" />
                      <img className="vector-33" alt="Vector" src="/img/vec/img/vector-35.svg" />
                      <img className="vector-34" alt="Vector" src="/img/vec/img/vector-36.svg" />
                      <img className="vector-35" alt="Vector" src="/img/vec/img/vector-37.svg" />
                      <img className="vector-36" alt="Vector" src="/img/vec/img/vector-38.svg" />
                      <img className="vector-37" alt="Vector" src="/img/vec/img/vector-39.svg" />
                      <img className="vector-38" alt="Vector" src="/img/vec/img/vector-40.svg" />
                      <img className="vector-39" alt="Vector" src="/img/vec/img/vector-41.svg" />
                      <img className="vector-40" alt="Vector" src="/img/vec/img/vector-42.svg" />
                      <img className="vector-41" alt="Vector" src="/img/vec/img/vector-43.svg" />
                      <img className="vector-42" alt="Vector" src="/img/vec/img/vector-44.svg" />
                      <img className="vector-43" alt="Vector" src="/img/vec/img/vector-45.svg" />
                      <img className="vector-44" alt="Vector" src="/img/vec/img/vector-46.svg" />
                      <img className="vector-45" alt="Vector" src="/img/vec/img/vector-47.svg" />
                      <img className="vector-46" alt="Vector" src="/img/vec/img/vector-48.svg" />
                      <img className="vector-47" alt="Vector" src="/img/vec/img/vector-49.svg" />
                      <img className="vector-48" alt="Vector" src="/img/vec/img/vector-50.svg" />
                      <div className="text-wrapper-2">JS</div>
                      <div className="text-wrapper-3">JS</div>
                      <div className="group">
                        <div className="group-2">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-3">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-4">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                      </div>
                      <div className="group-5">
                        <div className="group-2">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-3">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-4">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                      </div>
                      <div className="group-6">
                        <div className="group-2">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-3">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                        <div className="group-4">
                          <div className="ellipse" />
                          <div className="ellipse-2" />
                          <div className="ellipse-3" />
                        </div>
                      </div>
                      <img className="star" alt="Star" src="/img/vec/img/star-6.svg" />
                      <img className="star-2" alt="Star" src="/img/vec/img/star-6.svg" />
                      <img className="star-3" alt="Star" src="/img/vec/img/star-6.svg" />
                    </div>
                    <div className="group-7">
                      <div className="group-2">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                      <div className="group-3">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                      <div className="group-4">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                    </div>
                    <div className="group-8">
                      <div className="group-2">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                      <div className="group-3">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                      <div className="group-4">
                        <div className="ellipse" />
                        <div className="ellipse-2" />
                        <div className="ellipse-3" />
                      </div>
                    </div>
                  </div>
                  <div className="group-9">
                    <div className="group-2">
                      <div className="ellipse" />
                      <div className="ellipse-2" />
                      <div className="ellipse-3" />
                    </div>
                    <div className="group-3">
                      <div className="ellipse" />
                      <div className="ellipse-2" />
                      <div className="ellipse-3" />
                    </div>
                    <div className="group-4">
                      <div className="ellipse" />
                      <div className="ellipse-2" />
                      <div className="ellipse-3" />
                    </div>
                  </div>
                  <img className="star-4" alt="Star" src="/img/vec/img/star-6.svg" />
                </div>
                <img className="star-5" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-6" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-7" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-8" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-9" alt="Star" src="/img/vec/img/star-6.svg" />
              </div>
              <img className="star-10" alt="Star" src="/img/vec/img/star-6.svg" />
            </div>
            <div className="group-10">
              <div className="group-11">
                <div className="ellipse-4" />
                <div className="ellipse-5" />
                <div className="ellipse-6" />
              </div>
              <div className="group-12">
                <div className="ellipse-4" />
                <div className="ellipse-5" />
                <div className="ellipse-6" />
              </div>
              <div className="group-13">
                <div className="ellipse-4" />
                <div className="ellipse-5" />
                <div className="ellipse-6" />
              </div>
            </div>
          </div>
          <div className="overlap-4">
            <div className="overlap-5">
              <div className="overlap-6">
                <img className="star-11" alt="Star" src="/img/vec/img/star-6.svg" />
                <img
                  className="undraw-static-assets"
                  alt="Undraw static assets"
                  src="/img/vec/img/undraw-static-assets-rpm6-1.svg"
                />
                <div className="text-wrapper-4">JAVASCRIPT</div>
                <div className="text-wrapper-5">MODERN</div>
                <div className="text-wrapper-6">FROM THE BEGINNING</div>
              </div>
              <div className="overlap-7">
                <img className="polygon" alt="Polygon" src="/img/vec/img/polygon-2.svg" />
                <img className="polygon-2" alt="Polygon" src="/img/vec/img/polygon-3.svg" />
                <img className="polygon-3" alt="Polygon" src="/img/vec/img/polygon-1.svg" />
                <img className="star-12" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-13" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-14" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-15" alt="Star" src="/img/vec/imgc/star-6.svg" />
                <img className="star-16" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-17" alt="Star" src="/img/vec/img/star-6.svg" />
                <img className="star-18" alt="Star" src="/img/vec/img/star-6.svg" />
              </div>
              <img className="star-19" alt="Star" src="/img/vec/img/star-6.svg" />
              <img className="star-20" alt="Star" src="img/vec/img/star-6.svg" />
            </div>
            <img className="star-21" alt="Star" src="/img/vec/img/star-6.svg" />
          </div>
          <div className="group-14">
            <div className="group-2">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-3">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-4">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
          </div>
          <div className="group-15">
            <div className="group-2">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-3">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-4">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
          </div>
          <div className="group-16">
            <div className="group-2">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-3">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
            <div className="group-4">
              <div className="ellipse" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
          </div>
          <img className="star-22" alt="Star" src="/img/vec/img/star-6.svg" />
          <img className="star-23" alt="Star" src="/img/vec/img/star-6.svg" />
          <img className="star-24" alt="Star" src="/img/vec/img/star-6.svg" />
        </div>
      </div>
    </div>
    </div>
  )
}

export default CoursePageSingle